import axios from 'axios';
import {API} from "@/services/url";

export default {
	getModuleList: (success, error) => {
		axios.get(API.modules.moduleList).then(
			r => success(r.data.modules)
		).catch(
			e => error(e.response.data.message)
		);
	},
	storeModule: (module, success, error) => {
		axios.post(API.modules.moduleStore, module)
			.then(
				r => {
					success(r.data)
				}
			).catch(
			e => error(e.response.data.message)
		);
	}
}
